export const H3_FONT_WEIGHT = 600;
export const H6_FONT_WEIGHT = 600;
export const HEADING_LETTER_SPACING = 2;
